import StaticField from "./StaticField";

export default StaticField;
